/**
 * Paleta categorica del informe.
 *
 * Son los ocho slots de la paleta de referencia, validados con el script de
 * la guia de visualizacion en los dos modos (pares adyacentes):
 *   light  CVD dE 9.1 · vision normal dE 19.6 · 3 slots por debajo de 3:1
 *   dark   CVD dE 8.4 · vision normal dE 19.3 · todos por encima de 3:1
 *
 * El aviso de contraste en modo claro obliga a "relief": por eso el donut
 * siempre lleva leyenda con el valor escrito y la tabla completa debajo, nunca
 * identifica una porcion solo por su color.
 *
 * Los slots se asignan en orden fijo y NO se reciclan: a partir del sexto todo
 * cae en "Otros", que va en gris porque no es una identidad, es un resto.
 */

export const SERIES_LIGHT = [
  '#2a78d6', // 1 azul
  '#eb6834', // 2 naranja
  '#1baf7a', // 3 aqua
  '#eda100', // 4 amarillo
  '#e87ba4', // 5 magenta
  '#008300', // 6 verde
  '#4a3aa7', // 7 violeta
  '#e34948', // 8 rojo
]

export const SERIES_DARK = [
  '#3987e5',
  '#d95926',
  '#199e70',
  '#c98500',
  '#d55181',
  '#008300',
  '#9085e9',
  '#e66767',
]

export const OTROS_LIGHT = '#a8a69f'
export const OTROS_DARK = '#5c5b57'

/**
 * Maximo de porciones de un grafico de sectores. La guia lo fija en 6: por
 * encima, las clases adyacentes se confunden y toca leerlo en la tabla.
 */
export const MAX_SECTORES = 6

export function esModoOscuro() {
  const stamp = document.documentElement.dataset.theme
  if (stamp === 'dark') return true
  if (stamp === 'light') return false
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
}

/**
 * Reparte los datos en top (MAX_SECTORES - 1) + "Otros".
 * @param {Array<{id: string, name: string, value: number}>} items
 */
export function agruparParaSectores(items, { max = MAX_SECTORES, etiquetaResto = 'Otros' } = {}) {
  const ordenados = [...items].filter((i) => i.value > 0).sort((a, b) => b.value - a.value)
  if (ordenados.length <= max) return ordenados.map((item, i) => ({ ...item, slot: i }))

  const cabeza = ordenados.slice(0, max - 1).map((item, i) => ({ ...item, slot: i }))
  const resto = ordenados.slice(max - 1)
  cabeza.push({
    id: '__otros__',
    name: etiquetaResto,
    value: resto.reduce((s, r) => s + r.value, 0),
    slot: -1,
    agrupa: resto.length,
    detalle: resto,
  })
  return cabeza
}

export function colorDeSlot(slot, oscuro) {
  if (slot < 0) return oscuro ? OTROS_DARK : OTROS_LIGHT
  const serie = oscuro ? SERIES_DARK : SERIES_LIGHT
  return serie[slot % serie.length]
}
